import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import SVGInject from "@iconfu/svg-inject";
import {wpAdminbar} from "./components/wp.adminbar";
import {wpSearch} from "./components/wp.search";
import {helperBackgroundimageRounder} from "./components/helper.backgroundimage.rounder";
import {blockGalleryFetch} from "./blocks/block.galleryFetch";
import {yoastBreadcrumb} from "./components/yoast.breadcrumb";
import menus from "./components/wp.mobilemenu";
import {blockImageContent} from "./blocks/block.imageContent";
import {blockLottie} from "./blocks/block.lottie";
import {blockGalleryLightbox} from "./blocks/block.galleryLightbox";
import {blockVideo} from "./blocks/block.video";
import {blockLastestNews} from "./blocks/block.lastestNews";
import {siteIntersectionObserver} from "./components/site.intersectionObserver";
import {blockImageColumns} from "./blocks/block.imageColumns";
import {blockStats} from "./blocks/block.stats";

document.addEventListener("DOMContentLoaded", function () {
    window.Alpine = Alpine;
    SVGInject(document.querySelectorAll("img.injectable"));
    wpAdminbar();
    wpSearch();
    helperBackgroundimageRounder()
    yoastBreadcrumb();
    blockGalleryFetch();
    blockGalleryLightbox();
    blockImageContent();
    blockImageColumns();
    blockLottie();
    blockVideo();
    blockLastestNews();
    blockStats()
    siteIntersectionObserver();


    Alpine.data("mobilmenu", menus);

    Alpine.plugin(focus)

    Alpine.start()
});